var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVitamineB9(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "vitamine-b9_svg__svg81",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 200 195.3",
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".vitamine-b9_svg__st0{fill-rule:evenodd;clip-rule:evenodd}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vitamine-b9_svg__g78"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vitamine-b9_svg___x3C_Group_x3E_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "vitamine-b9_svg___x3C_Path_x3E_",
    d: "M97.7 195.3C43.9 195.3 0 151.4 0 97.5c0-19.3 5.7-38 16.4-54.1 1.9-2.9 5.9-3.8 8.8-1.7 3.1 1.9 3.8 5.9 1.9 9C17.8 64.5 13 80.8 13 97.5c0 46.8 38 84.8 84.8 84.8 8.1 0 16.2-1.2 24-3.5 3.5-1 6.9.9 7.9 4.3 1 3.5-.9 7.1-4.3 8.1-9 2.7-18.3 4.1-27.7 4.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "vitamine-b9_svg__g20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "vitamine-b9_svg___x3C_Compound_Path_x3E_",
    className: "vitamine-b9_svg__st0",
    d: "M57 133.4V62.1h13.8c5.4 0 10.2.2 14.7 3.8 4.7 3.8 7.3 10.2 7.3 16.1 0 6.4-2.2 11.2-7.6 14.9 5.9 2.8 8.8 10.4 8.8 16.6 0 14-10.4 20-23.3 20H57zm14.1-59.5v17.4c5.2 0 8.3-3.6 8.3-9 0-5.2-2.9-8.6-8.3-8.4zm0 28.5v19.2c5.7.3 9-3.8 9-9.8 0-5.6-3.4-9.6-9-9.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vitamine-b9_svg__path18",
    className: "vitamine-b9_svg__st0",
    d: "M110.5 133.4l13.6-28-.2-.2c-2.6 2.4-5.2 4-9 4-10.7 0-14.3-13.6-14.3-22.3 0-12.6 5-26.1 20-26.1 14.2 0 19.5 12.6 19.5 25 0 13-4.8 23.8-10.2 35.2l-5.9 12.3h-13.5zm3.8-47.8c0 3.5.9 11.2 5.7 11.2 5.5 0 6.4-8.8 6.4-12.4 0-3.5-1.2-11.4-5.9-11.2-5.5 0-6.2 8.8-6.2 12.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "vitamine-b9_svg__g76"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vitamine-b9_svg__g26"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vitamine-b9_svg__g24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "vitamine-b9_svg__path22",
    d: "M48.7 32.9c1.6-4.8-1.2-9.8-6-11.2-4.7-1.6-9.7 1.2-11.1 6-1.6 4.7 1.2 9.7 5.9 11.1 4.8 1.6 9.8-1.2 11.2-5.9z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "vitamine-b9_svg__g32"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vitamine-b9_svg__g30"
  }, /*#__PURE__*/React.createElement("path", {
    id: "vitamine-b9_svg__path28",
    d: "M80.3 16.5c1.6-5.2-1.4-10.5-6.6-12.1-5-1.6-10.4 1.4-11.9 6.6-1.6 5 1.2 10.4 6.4 11.9 5.2 1.6 10.5-1.4 12.1-6.4z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "vitamine-b9_svg__g38"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vitamine-b9_svg__g36"
  }, /*#__PURE__*/React.createElement("path", {
    id: "vitamine-b9_svg__path34",
    d: "M103.1 20.2c5.5 1.7 11.2-1.4 13-6.9 1.6-5.4-1.4-11.2-6.9-12.8-5.5-1.7-11.2 1.4-13 6.9-1.6 5.3 1.5 11.2 6.9 12.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "vitamine-b9_svg__g44"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vitamine-b9_svg__g42"
  }, /*#__PURE__*/React.createElement("path", {
    id: "vitamine-b9_svg__path40",
    d: "M150.1 23.6c1.7-5.9-1.6-11.9-7.3-13.8-5.9-1.7-12.1 1.6-13.8 7.4-1.7 5.9 1.6 11.9 7.4 13.6 5.9 1.8 11.9-1.5 13.7-7.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "vitamine-b9_svg__g50"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vitamine-b9_svg__g48"
  }, /*#__PURE__*/React.createElement("path", {
    id: "vitamine-b9_svg__path46",
    d: "M155.8 39.2c-1.9 6.2 1.6 12.8 7.8 14.7 6 1.7 12.6-1.7 14.5-7.9 1.9-6-1.7-12.6-7.8-14.5-6.2-1.8-12.8 1.6-14.5 7.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "vitamine-b9_svg__g56"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vitamine-b9_svg__g54"
  }, /*#__PURE__*/React.createElement("path", {
    id: "vitamine-b9_svg__path52",
    d: "M179.9 85.4c6.6 1.9 13.3-1.7 15.4-8.3 1.9-6.4-1.7-13.3-8.3-15.4-6.6-1.9-13.5 1.7-15.4 8.3-1.9 6.6 1.8 13.5 8.3 15.4z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "vitamine-b9_svg__g62"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vitamine-b9_svg__g60"
  }, /*#__PURE__*/React.createElement("path", {
    id: "vitamine-b9_svg__path58",
    d: "M174.6 105c-2.1 6.9 1.7 14.2 8.6 16.2 6.9 2.1 14.2-1.9 16.2-8.8s-1.9-14-8.8-16.1c-6.9-2.1-13.9 1.7-16 8.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "vitamine-b9_svg__g68"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vitamine-b9_svg__g66"
  }, /*#__PURE__*/React.createElement("path", {
    id: "vitamine-b9_svg__path64",
    d: "M172.9 155.2c7.3 2.1 14.9-1.9 17.1-9.2 2.2-7.3-1.9-14.9-9.2-17.1-7.3-2.1-14.9 1.9-16.9 9.2-2.3 7.3 1.9 14.9 9 17.1z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "vitamine-b9_svg__g74"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vitamine-b9_svg__g72"
  }, /*#__PURE__*/React.createElement("path", {
    id: "vitamine-b9_svg__path70",
    d: "M150.6 183.4c7.6 2.2 15.5-1.9 18-9.5 2.2-7.6-2.1-15.5-9.7-18-7.6-2.2-15.5 2.1-17.8 9.7-2.3 7.6 1.9 15.5 9.5 17.8z"
  })))))));
}
export default SvgVitamineB9;